<div class="adjust-dialog">
  <div class="header">
    <span>Create Transaction Adjustment</span>
    <button class="close-btn" type="button" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="adjustmentForm" (ngSubmit)="onSubmit()">
    <div class="input-container">
      <div class="form-field">
        <app-dropdown
          label="Type of Adjustment"
          placeholder="Select adjustment type"
          [options]="adjustmentTypeOptions"
          formControlName="adjustmentType"
          [isInvalid]="getFieldError('adjustmentType', 'Adjustment type') !== ''"
          [errorMessage]="getFieldError('adjustmentType', 'Adjustment type')"
        ></app-dropdown>
      </div>

      <div class="form-field">
        <app-text-input
          label="Adjustment Amount ($)"
          placeholder="Adjustment amount ($)"
          type="number"
          formControlName="amount"
          [isInvalid]="getFieldError('amount', 'Adjustment Amount') !== ''"
          [errorMessage]="getFieldError('amount', 'Adjustment Amount')"
        ></app-text-input>
      </div>

      <div class="form-field">
        <app-dropdown
          label="Reason"
          placeholder="Select adjustment reason"
          [options]="adjustmentReasonOptions"
          formControlName="adjustmentReason"
          [isInvalid]="getFieldError('adjustmentReason', 'Adjustment reason') !== ''"
          [errorMessage]="getFieldError('adjustmentReason', 'Adjustment reason')"
        ></app-dropdown>
      </div>
    </div>

    <div class="buttons">
      <app-button buttonVariant="dialog-secondary" buttonType="button" (buttonClick)="onClose()">Cancel</app-button>

      <app-button
        buttonVariant="dialog-primary"
        buttonType="submit"
        [state]="nextButtonState"
      >
        Next
      </app-button>
    </div>
  </form>
</div>
